import type { Promo } from '../../../../types/Deal';
import type Localiser from '../../../Localiser';

import { decodeCustomPromos } from './decodeCustomPromos';

export const addCustomPromos = ({
  localiser,
  customPromo,
  customPromos,
  promos,
}: {
  localiser: Localiser;
  customPromo?: string;
  customPromos?: string;
  promos: Promo[];
}): Promo[] => {
  if (customPromos) {
    const customPromosArray = decodeCustomPromos(customPromos);
    const arrayOfPromos = customPromosArray.map((element) => {
      return {
        type: 'custom-promo',
        value: localiser.translate(element),
        display_value: localiser.translate(element),
      };
    });

    return arrayOfPromos.concat(promos);
  }
  if (customPromo) {
    return [
      {
        type: 'custom-promo',
        value: localiser.translate(customPromo),
        display_value: localiser.translate(customPromo),
      },
    ].concat(promos);
  }
  return promos;
};
